<template>
  <div class="afiliasi-card-wrapper">
    <div v-for="(data, key) in dataAfiliated" :key="`card-afiliated-${key}`" class="m-d-12">
      <SOSlotCard :card-type="typeCard" :dropdown-menu="`card`">
        <template v-slot:card_head>
          <div class="f-c-black f-16 f-regular d-grid-2">
            <div>{{ data.nama }}</div>
            <div class="card-menu-vertical j-self-end"></div>
          </div>
        </template>
        <template v-slot:card_body>
          <div class="d-grid-1">
            <label class="m-d-0 f-12" style="color: #C8D0DD">Bergabung sejak: {{ data.tanggal_gabung }}</label>
            <label class="m-d-0">
              {{ data.email }}
            </label>
            <label class="m-d-0"> +{{ data.telp.countryCode }} {{ phoneNumber(data.telp.telpDisplay) }} </label>
          </div>
        </template>
        <template v-slot:card_footer>
          <div>
            <label class="m-d-0">
              <img src="@/assets/icons/mood-happy.svg" alt="" class="m-r-4" style="height: 13px; margin-top: -2px" />
              <span class="f-13 f-c-midgrey f-regular badge color-green"  v-if="data.outlet_aktif>0">
                {{ data.outlet_aktif }} Aktif dari {{ data.total_outlet }} Outlet terdaftar
              </span>
              <span class="f-13 f-c-midgrey f-regular badge color-red"  v-else-if="data.total_outlet==0">
                Belum Membuat Outlet
              </span>
              <span class="f-13 f-c-midgrey f-regular badge color-red" v-else>
                Belum Aktivasi
              </span>

            </label>
          </div>
        </template>
        <template v-slot:menu_card>
          <div>
            <a class="dropdown-item p-x-8" :href="'tel:' + data.telp.telpNum" target="_blank">
              <span class="m-r-8">
                <img src="@/assets/icons/phone-call.svg">
              </span>
              Telepon
            </a>
            <a class="dropdown-item p-x-8" :href="'sms:' + data.telp.telpNum" target="_blank">
              <span class="m-r-8">
                <img src="@/assets/icons/email.svg">
              </span>
              SMS
            </a>
            <a class="dropdown-item p-x-8" :href="'http://wa.me/' + data.telp.telpNum" target="_blank">
              <span class="m-r-8">
                <img src="@/assets/icons/mdi_whatsapp.svg">
              </span>
              Whatsapp
            </a>
          </div>
        </template>
      </SOSlotCard>
    </div>
  </div>
</template>

<script>
import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

export default {
  name: "SOCardAfiliated",
  props: {
    cardType: {
      type: String,
      required: true,
    },
    dataAfiliated: {
      type: Array,
      required: true,
    },
  },
  components: {
    SOSlotCard,
  },
  computed: {
    typeCard() {
      return this.cardType;
    },
    phoneNumber() {
      return (phone) => {
        return phone.replace("0", "");
      };
    },
  },
};
</script>

<style scoped src="../styleScope.css"></style>
